<template>
  <div class="pos-r" v-if="notice.ad_title && notice.noticecontent">
    <van-notice-bar
      @click="bannerClick"
      style="border-radius: 0.1rem; height: 0.33rem"
      :mode="notice.ad_type && notice.ad_type != '0' ? 'link' : ''"
      color="#333333"
      background="#ffffff"
      left-icon="volume"
      delay="5"
      speed="30"
    >
      <b>{{ notice.ad_title }}</b>
      {{ notice.noticecontent }}
    </van-notice-bar>
    <div
      :path="notice.ad_target + (notice.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=16'"
      :username="'gh_5d4bb8e18b8b'"
      class="slide_cl_xcx"
      v-if="isWx && (notice.ad_type == 7 || notice.ad_type == 8)"
    ></div>
  </div>
</template>

<script>
import { isWeixin, bannerClick } from '../../../assets/common/js/config'
export default {
  props: {
    notice: {
      type: Object,
      default: function () {
        return {}
      }
    },
    /** 埋点 flowArea 前缀，如 channelZone */
    flow_area_prefix: {
      type: String,
      default: 'NOTICE'
    }
  },
  data() {
    return {
      isWx: isWeixin() ? 1 : 0
    }
  },
  methods: {
    bannerClick() {
      bannerClick(this.notice, 0, this.flow_area_prefix, this, () => {
        this.dataCollection(this.notice, 0, this.flow_area_prefix)
      })
    },
    dataCollection(item, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea == '热门直播' ? item.name : item.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : item.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? item.name : item.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/homepage/components/actScroll.vue